// src/api/modelesAccueil.api.ts — SCE Issues
// Les modèles d'accueil par rôle réglés dans /admin (lot 6 du chantier du 03/11,
// docs/chantier-accueil.md) : bloc `modelesAccueil` de la ligne `__global__` de
// SCE_UserPrefs, `{ version: 1, modeles: { coordinateur?, administrateur? } }`.
// Bloc absent = modèles du code. Relu avant chaque écriture (modifierBlocGlobal).

import { lireBlocGlobal, modifierBlocGlobal } from './reglagesGlobaux.api'
import { lireModelesAccueil, type ModeleEnregistre, type ModelesEnregistres, type RoleAccueil } from '@/utils/dispositionAccueil'

const BLOC = 'modelesAccueil'

export async function lireModeles(): Promise<ModelesEnregistres> {
  return lireModelesAccueil(await lireBlocGlobal(BLOC))
}

/** Remplace le modèle d'UN rôle (null : retour au modèle du code), les autres restent tels quels. */
export async function enregistrerModele(role: RoleAccueil, modele: ModeleEnregistre | null): Promise<ModelesEnregistres> {
  let resultat: ModelesEnregistres = {}
  await modifierBlocGlobal(BLOC, (actuel) => {
    const modeles: ModelesEnregistres = { ...lireModelesAccueil(actuel) }
    if (modele) modeles[role] = modele
    else delete modeles[role]
    resultat = modeles
    return { version: 1, modeles }
  })
  return resultat
}
